import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Cppbar from '../Bars/Cppbar';
import Button from 'react-bootstrap/Button'
function Creturnvalue(){
return(
    <div>
       
    <h1>return function in c</h1>
<div className="first">
        <a href="/csharp-control-structure">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-3 para">A function can return only one value at a time and this type of function will no be defined with void data type</p>

<Card border="primary  m-5">
  <Card.Header as="h5">Q-write a program to check minimum no by using return?
</Card.Header>
  <Card.Body>
    <Card.Text>
 <p> #include&#60;stdio.h><br/>
#include&#60;conio.h><br/>
Void maximum(int a,int b)<br/>
&#123;<br/>
If(a>b)<br/>
Return (a);<br/>
Else<br/>
Return(b);<br/>
}<br/>
Void main()<br/>
&#123;<br/>
Int a,b,m;<br/>
Printf("enter a  no");<br/>
Scanf(“%d%d”,&#38;a,&#38;b);<br/>
M=Maximum(a,b);<br/>
Printf(“minimum no =%d”,m)<br/>
}<br/>
&#125;<br/>
</p>  
    </Card.Text>
  </Card.Body>
  
</Card>
<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/csharp-goto">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-oops">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div>
)

}
export default Creturnvalue;